import Queries from './queries.container';

export default Queries;
